import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { PwaLandingRedirect } from '@/features/app/presentation/components/PwaLandingRedirect';
import HomePage from '@/features/home/page';
import { LoginScreen } from '@/features/authentication/presentation/screens/LoginScreen';
import { OnboardingScreen } from '@/features/authentication/presentation/screens/OnboardingScreen';
import AppPage from '@/routes/AppPage';
import {
  AppClientsRoute,
  AppDashboardRoute,
  AppFaqSuporteRoute,
  AppIndexRedirect,
  AppLembretesEnviadosRoute,
  AppListaServicosRoute,
  AppManutencoesAgendadasRoute,
  AppMinhaContaRoute,
  AppPlanosRoute,
  AppRegisterServiceRoute,
  AppReminderSettingsRoute,
} from '@/routes/app-section-route-wrappers';
import { ChoosePlanScreen } from '@/features/plans/presentation/screens/ChoosePlanScreen';
import { VerifySubscriptionScreen } from '@/features/payments/presentation/screens/VerifySubscriptionScreen';
import { ROUTES, appSectionPath } from '@/app/routes';
import { APP_SECTION } from '@/features/app/constants/sections';
import AdminPage from '@/features/admin/presentation/pages/AdminPage';
import NotFoundPage from '@/routes/NotFoundPage';

export function App() {
  return (
    <>
      <PwaLandingRedirect />
      <Routes>
        <Route path={ROUTES.ROOT} element={<Navigate to={ROUTES.HOME} replace />} />
        <Route path={ROUTES.HOME} element={<HomePage />} />
        <Route path={ROUTES.LOGIN} element={<LoginScreen />} />
        <Route path={ROUTES.SIGNUP} element={<Navigate to={ROUTES.LOGIN} replace />} />
        <Route path={ROUTES.AUTH_ONBOARDING} element={<OnboardingScreen />} />
        <Route path={ROUTES.CHOOSE_PLAN} element={<ChoosePlanScreen />} />
        <Route path={ROUTES.VERIFY_SUBSCRIPTION} element={<VerifySubscriptionScreen />} />
        <Route path={ROUTES.APP} element={<AppPage />}>
          <Route index element={<AppIndexRedirect />} />
          <Route path={APP_SECTION.DASHBOARD} element={<AppDashboardRoute />} />
          <Route path={APP_SECTION.REGISTRAR_SERVICO} element={<AppRegisterServiceRoute />} />
          <Route path={APP_SECTION.SERVICOS} element={<AppListaServicosRoute />} />
          <Route path={APP_SECTION.CLIENTES} element={<AppClientsRoute />} />
          <Route path={APP_SECTION.LEMBRETES_ENVIADOS} element={<AppLembretesEnviadosRoute />} />
          <Route path={APP_SECTION.MANUTENCOES_AGENDADAS} element={<AppManutencoesAgendadasRoute />} />
          <Route path={APP_SECTION.TESTAR_ENVIO} element={<AppReminderSettingsRoute />} />
          <Route path={APP_SECTION.FAQ_SUPORTE} element={<AppFaqSuporteRoute />} />
          <Route path={APP_SECTION.MINHA_CONTA} element={<AppMinhaContaRoute />} />
          <Route path={APP_SECTION.PLANOS} element={<AppPlanosRoute />} />
          <Route path="*" element={<Navigate to={appSectionPath(APP_SECTION.DASHBOARD)} replace />} />
        </Route>
        <Route path={ROUTES.ADMIN} element={<AdminPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}
